export default class Figure extends Component {
  render() {
    const { children, isBoring } = this.props

    if (isBoring) return children
    return (
      <div
        style={{
          display: "grid",
          gridColumn: "screen",
          justifyContent: "center",
          borderTop: `1px solid rgba(0, 0, 0, 0.1)`,
          borderBottom: `1px solid rgba(0, 0, 0, 0.1)`,
          paddingTop: 20,
          paddingBottom: 20,
          marginTop: 20,
          marginBottom: 20,
          justifyContent: "center",
          background: "rgba(246,249,252,1)",
        }}
      >
        {children}
      </div>
    )
  }
}
